<template>
  <drag-dialog
    :visible.sync="visible"
    :title="`${activeId ? '编辑' : '新增'}委托信息`"
    width="100vw"
    height="100vh"
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form v-loading="detailLoading" :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item prop="reportCodeStart">
            <template #label>
              <div>
                <span>委托编号</span>
                <!-- <el-tooltip v-if="!activeId" effect="dark" :content="'当前已有的最大委托编号：' + maxCode" placement="bottom-end">
                  <i class="el-icon-warning"></i>
                </el-tooltip> -->
              </div>
            </template>
            <el-input v-model.trim="editForm.reportCodeStart" placeholder="请输入（示例：（2026）QS-1" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目名称" prop="projectName">
            <el-input v-model.trim="editForm.projectName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位" prop="client">
            <el-input v-model.trim="editForm.client" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="委托单位联系人" prop="sfcn">
            <el-input v-model.trim="editForm.sfcn" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系方式" prop="sfcp">
            <el-input v-model.trim="editForm.sfcp" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测地点" prop="testAddress">
            <el-input v-model.trim="editForm.testAddress" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="项目经理" prop="leaderId">
            <el-select v-model="editForm.leaderId" placeholder="请选择">
              <el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="班组成员" prop="entrustmentUserIds">
            <el-select v-model="editForm.entrustmentUserIds" multiple placeholder="请选择">
              <el-option v-for="item in userOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="使用车辆" prop="supervisionUnit">
            <el-select v-model="editForm.supervisionUnit" multiple placeholder="请选择">
              <el-option v-for="item in carOptions" :key="item.id" :label="item.carNo" :value="item.carNo"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="检测类别" prop="testType">
            <el-checkbox-group v-model="editForm.testType">
              <el-checkbox v-for="item in testTypeOptions" :key="item.code" :label="item.code">{{ item.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>

        <table class="word-table">
          <tr style="background-color: #f2f2f2">
            <td width="15%" class="label">检测项目</td>
            <td width="10%" class="label">数量</td>
            <td width="12.5%" class="label">试验项目</td>
            <td width="25%" class="label">现场图片</td>
            <td width="20%" class="label">检测清单</td>
            <td width="12.5%" class="label">工作量备注</td>
            <td width="5%" class="label">
              <el-button type="primary" size="mini" icon="el-icon-plus" circle @click="handleSampleAdd"></el-button>
            </td>
          </tr>
          <tr v-for="(item, index) in editForm.sampleInfoList" :key="index">
            <td class="align-Left">{{ item.testItemText }}</td>
            <td>
              <el-input type="number" v-model="item.cnt" style="width: 100%"></el-input>
            </td>
            <td>
              <el-input type="textarea" v-model="item.expItems" :rows="4" style="width: 100%"></el-input>
            </td>
            <td>
              <image-upload v-model="item.imgs" :modelType="2" :paramsData="{ type: 'upt_img' }"></image-upload>
            </td>
            <td>
              <upload-button v-model="item.files" :fileSize="50" :paramsData="{ type: 'upt_file' }"></upload-button>
            </td>
            <td>
              <el-input type="textarea" v-model="item.remark" :rows="4" style="100"></el-input>
            </td>
            <td>
              <el-button type="danger" size="mini" icon="el-icon-delete" circle @click="handleSampleDel(index)"></el-button>
            </td>
          </tr>
        </table>

        <el-col :span="12">
          <el-form-item label="商定检测日期" prop="sendDate">
            <el-date-picker
              v-model="editForm.sendDate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
              style="width: 200px"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="客户备注" prop="note">
            <el-input type="textarea" v-model="editForm.note" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="报告领取方式" prop="deliveryType">
            <el-radio-group v-model="editForm.deliveryType">
              <el-radio :label="0">自取</el-radio>
              <el-radio :label="1">邮寄（到付）</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="邮寄地址" prop="ivDdeliveryAddress">
            <el-input v-model="editForm.ivDdeliveryAddress" placeholder="请输入邮寄地址" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="内部备注" prop="noteInner">
            <el-input type="textarea" v-model="editForm.noteInner" placeholder="请输入（供内部查看）" clearable></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确 认</el-button>
    </div>

    <!-- 选择样品 -->
    <SampleSelect :visible.sync="sampleVisible" @setItemList="sampleCallback"></SampleSelect>
  </drag-dialog>
</template>

<script>
import SampleSelect from '@/views/system/sample/components/SampleSelect';
import ImageUpload from '@/components/UploadArea/ImageUpload';
import UploadButton from '@/components/UploadArea/UploadButton';

import { getDictsByCode, getCarList, getItem } from '@/api/system';
import { getEntrustmentSet, editEntrustmentSetJson, getReportCodeMax } from '@/api/entrust';
import { getUserListByCode } from '@/api/user';

export default {
  components: { SampleSelect, ImageUpload, UploadButton },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    activeId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      maxCode: '',
      editForm: {
        id: null,
        reportCodeStart: '', // 报告起始编号
        client: '', // 委托单位
        projectName: '', // 工程名称
        payOrg: '',
        builder: '',
        sfcn: '', // 送检人
        sfcp: '', // 联系电话
        sfca1: '', // 送检人地址部分1
        sfca2: '', // 送检人地址部分2
        sfca3: '', // 送检人地址部分3
        sfca: '', // 送检人地址部分4
        testType: [], // 检测类别
        supervisionUnit: [], // 使用车辆
        leaderId: null, // 项目经理
        entrustmentUserIds: [], // 班组成员
        isSbct: 0, // 是否接受分包至其他有资质的检测机构
        reportType: [0], // 出具报告类型
        sampleDealWay: null, // 样品处理方式
        deliveryType: 0, // 报告领取方式
        serviceType: null, // 服务类型
        note: '', // 特殊说明
        stmtWay: null, // 结算类型
        ivDdeliveryAddress: '', // 邮寄地址
        sendDate: null, // 商定检测日期
        noteInner: '', // 内部特殊说明
        etmtType: 'etmt_type_unvs', // 委托协议书类型
        scac: '',
        testAddress: '', // 检测地点
        sampleInfoList: [],
        basisTotalList: []
      },
      etmtTypeOptions: [],
      testTypeOptions: [],
      addressOptions: [],
      userOptions: [],
      carOptions: [],
      rules: {
        client: [{ required: true, message: '请输入', trigger: 'blur' }],
        testAddress: [{ required: true, message: '请输入', trigger: 'blur' }],
        sendDate: [{ required: true, message: '请选择', trigger: 'change' }],
        projectName: [{ required: true, message: '请输入', trigger: 'blur' }],
        payOrg: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcn: [{ required: true, message: '请输入', trigger: 'blur' }],
        sfcp: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error('请输入联系方式'));
              } else if (!/^1[3-9]\d{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
              } else {
                callback(); // 验证通过
              }
            },
            trigger: 'blur'
          }
        ],
        leaderId: [{ required: true, message: '请选择', trigger: 'change' }],
        entrustmentUserIds: [{ required: true, message: '请选择', trigger: 'change' }],
        testType: [{ required: true, message: '请选择', trigger: 'change' }],
        reportType: [{ required: true, message: '请选择', trigger: 'change' }],
        sampleDealWay: [{ required: true, message: '请选择', trigger: 'change' }],
        deliveryType: [{ required: true, message: '请选择', trigger: 'change' }],
        serviceType: [{ required: true, message: '请选择', trigger: 'change' }],
        stmtWay: [{ required: true, message: '请选择', trigger: 'change' }],
        scac: [{ required: true, message: '请选择', trigger: 'change' }]
      },
      detailLoading: false,
      submitLoading: false,
      sampleVisible: false
    };
  },
  computed: {},
  watch: {
    async visible(val) {
      if (val) {
        await this.getDictsByCode('test_type', 'testTypeOptions');
        await this.getCarList();
        await this.getUserOpetions();

        if (this.activeId) {
          this.getDetailData();
        } else {
          this.getReportCodeMax();
        }
      }
    }
  },
  methods: {
    async getReportCodeMax() {
      const { data } = await getReportCodeMax({ type: '' });
      this.editForm.reportCodeStart = data?.reportCodeStart ?? '';
      this.maxCode = data?.maxCode ?? '';
    },
    async getUserOpetions() {
      const { data: testedByData } = await getUserListByCode({ roleCode: 'JCY' });
      const { data: auditedByData } = await getUserListByCode({ roleCode: 'SHY' });
      const { data: approvedByData } = await getUserListByCode({ roleCode: 'PZY' });
      const testedBys = testedByData?.list || [];
      const auditedBys = auditedByData?.list || [];
      const approvedBys = approvedByData?.list || [];

      // 使用 Map 根据 id 去重
      const userMap = new Map();
      [...testedBys, ...auditedBys, ...approvedBys].forEach(user => {
        if (!userMap.has(user.id)) {
          userMap.set(user.id, user);
        }
      });

      this.userOptions = Array.from(userMap.values());
    },
    // 编辑时获取详情
    async getDetailData() {
      this.detailLoading = true;

      try {
        const { data } = await getEntrustmentSet({ id: this.activeId });
        const testType = data?.testType ? data.testType.split(',') : [];
        const supervisionUnit = data?.supervisionUnit ? data.supervisionUnit.split(',') : [];
        const entrustmentUserIds = data?.entrustmentUserList ? data.entrustmentUserList.map(item => item.userId) : [];
        const sampleInfoList = data?.sampleInfoList || [];

        sampleInfoList.forEach(item => {
          if (item.imgs) {
            if (this.isJSONObjectOrArray(item.imgs)) {
              const allFiles = JSON.parse(item.imgs);
              item.imgs = allFiles.imgs;
              item.files = allFiles.files;
            } else {
              item.imgs = item.imgs;
              item.files = [];
            }
          } else {
            item.imgs = '';
            item.files = [];
          }
        });

        this.editForm = { ...this.editForm, ...data, testType, supervisionUnit, entrustmentUserIds };
        this.$nextTick(() => {
          this.$refs.editForm.clearValidate();
        });
      } finally {
        this.detailLoading = false;
      }
    },
    isJSONObjectOrArray(str) {
      if (typeof str !== 'string') return false;
      try {
        const parsed = JSON.parse(str);
        return typeof parsed === 'object' && parsed !== null;
      } catch (e) {
        return false;
      }
    },
    handleSampleAdd() {
      this.sampleVisible = true;
    },
    sampleCallback(sampleList) {
      const processSamples = async () => {
        const processedSamples = await Promise.all(
          sampleList.map(async item => {
            const basisList = await this.getItemBasis(item.testItemId);
            const testItems = basisList.map(basis => {
              return {
                sampleName: item.remark,
                itemId: item.testItemId,
                itemName: item.testItem,
                sampleId: item.id,
                basisId: basis.basisId,
                basisCode: '',
                basisName: basis.basisName
              };
            });
            return {
              sampleId: item.id,
              sampleName: item.remark,
              cnt: 1,
              testItemText: item.testItem || '',
              testItems: JSON.stringify(testItems), // 将basisList转换为JSON字符串存储
              expItems: '',
              imgs: '',
              files: [],
              remark: ''
            };
          })
        );

        this.editForm.sampleInfoList = [...this.editForm.sampleInfoList, ...processedSamples];
      };

      processSamples();
    },
    async getItemBasis(id) {
      const { data } = await getItem({ id });

      const basisList = data.basisList ?? [];
      return basisList;
    },
    handleSampleDel(index) {
      this.editForm.sampleInfoList.splice(index, 1);
    },
    async getCarList() {
      const { data } = await getCarList({
        pageSize: 999
      });
      this.carOptions = data?.list || [];
    },
    handleSubmit() {
      const { deliveryType, ivDdeliveryAddress, sampleInfoList } = this.editForm;

      if (!this.editForm.sampleInfoList || this.editForm.sampleInfoList.length == 0)
        return this.$message.warning('请添加检测项目信息！');
      if (deliveryType == 1 && !ivDdeliveryAddress) return this.$message.warning('请输入邮寄地址！');

      this.$refs.editForm.validate(async valid => {
        if (valid) {
          this.submitLoading = true;
          // 处理样品信息
          const sampleInfoListValue = sampleInfoList.map((item, index) => {
            const imgs = JSON.stringify({
              imgs: item.imgs,
              files: item?.files || []
            });

            return {
              ...item,
              imgs,
              eng: index + 1
            };
          });
          const testType = this.editForm.testType.join(',');
          const supervisionUnit = this.editForm.supervisionUnit.join(',');

          // 构建项目成员
          const leader = this.userOptions.find(user => user.id === this.editForm.leaderId);
          const selectedUsers = this.userOptions.filter(user => this.editForm.entrustmentUserIds.includes(user.id));
          const entrustmentUserList = selectedUsers.map(user => ({
            userId: user.id,
            userName: user.name
          }));

          const params = {
            id: this.editForm.id,
            reportCodeStart: this.editForm.reportCodeStart,
            client: this.editForm.client,
            projectName: this.editForm.projectName,
            payOrg: this.editForm.payOrg,
            builder: this.editForm.builder,
            sfcn: this.editForm.sfcn,
            sfcp: this.editForm.sfcp,
            sfca1: this.editForm.sfca1,
            sfca2: this.editForm.sfca2,
            sfca3: this.editForm.sfca3,
            sfca: this.editForm.sfca,
            testType,
            supervisionUnit,
            sampleInfoList: sampleInfoListValue,
            isSbct: this.editForm.isSbct,
            sampleDealWay: this.editForm.sampleDealWay,
            deliveryType: this.editForm.deliveryType,
            serviceType: this.editForm.serviceType,
            note: this.editForm.note,
            stmtWay: this.editForm.stmtWay,
            ivDdeliveryAddress: this.editForm.ivDdeliveryAddress,
            sendDate: this.editForm.sendDate,
            scac: this.editForm.scac,
            testAddress: this.editForm.testAddress,
            noteInner: this.editForm.noteInner,
            etmtType: 'etmt_type_unvs',
            leaderId: this.editForm.leaderId,
            leaderName: leader ? leader.name : '',
            entrustmentUserList
          };

          try {
            await editEntrustmentSetJson(params);
            this.$message.success('提交成功!');
            this.$emit('update:visible', false);
            this.$emit('refresh');
          } finally {
            this.submitLoading = false;
          }
        } else {
          this.$message.warning('请完善必填项!');
        }
      });
    },
    // 获取字典
    async getDictsByCode(code, dataType) {
      const { data } = await getDictsByCode({ code });
      this[dataType] = data;
    }
  },

  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-button--mini.is-circle {
  padding: 5px;
}

.word-table {
  margin: 0 40px 20px 40px;
}
.el-select {
  width: 100%;
}

.break-radio {
  .el-radio {
    margin-bottom: 10px;
  }
  .radio-line {
    display: flex;
    align-items: center;
    .el-radio {
      margin-bottom: 0;
    }
  }
}
</style>
